import { Fragment } from "react";
import { Text, TagLabel, Spacer } from "@zapier/design-system";
import { css } from "@emotion/react";

const titleContainerStyle = css`
  display: flex;
  align-items: center;
`;

const descriptionContainerStyle = css`
  display: flex;
  flex-direction: column;
`;

type PlanTitleProps = {
  description?: string | null;
  title: string;
  showCurrentTrialBadge: boolean;
};

/**
 * A component that displays a specified plan's title and description.
 */
export const PlanTitle = ({
  description,
  title,
  showCurrentTrialBadge,
}: PlanTitleProps) => {
  return (
    <Fragment>
      <div css={titleContainerStyle}>
        <Text
          color={"neutral800"}
          fontWeight={700}
          tag="h2"
          type="sectionHeader3Bold"
        >
          {title}
        </Text>
      </div>
      <div css={descriptionContainerStyle}>
        {showCurrentTrialBadge ? (
          <div>
            <TagLabel color="success" size="small">
              Current trial
            </TagLabel>
            <Spacer height={10} />
          </div>
        ) : null}
        <Text color="neutral800" tag="p" type="smallPrint1">
          {description}
        </Text>
      </div>
    </Fragment>
  );
};
